import { render, staticRenderFns } from "./kvkk-inventory.vue?vue&type=template&id=40e55a2c"
import script from "./kvkk-inventory.vue?vue&type=script&lang=js"
export * from "./kvkk-inventory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports